import { App } from '@capacitor/app';
import { isCapacitorNativeApk } from '@src/modules/shell-ui/infrastructure/shellPwaInstallUi.ts';

type BackHandler = () => boolean;

const handlers: BackHandler[] = [];

/** LIFO stack — top handler wins when Android hardware back is pressed. */
export function pushShellBackHandler(handler: BackHandler): () => void {
  handlers.push(handler);
  return () => {
    const i = handlers.lastIndexOf(handler);
    if (i >= 0) handlers.splice(i, 1);
  };
}

export function runShellBackHandlers(): boolean {
  for (let i = handlers.length - 1; i >= 0; i--) {
    try {
      if (handlers[i]()) return true;
    } catch {
      /* handler must not break back navigation */
    }
  }
  return false;
}

/** Mutable gate for double-back-to-exit on open forms (avoids wiping unsaved field work). */
export type ShellFormBackGate = { armedUntil: number };

export const SHELL_FORM_BACK_EXIT_HINT =
  'Pulse atrás otra vez para salir. Los datos no guardados se pierden.';

/** First back → hint + stay; second back within windowMs → close. Always consumes the event. */
export function handleShellFormBackExit(
  gate: ShellFormBackGate,
  close: () => void,
  hint: () => void,
  windowMs = 2000,
): boolean {
  const now = Date.now();
  if (now < gate.armedUntil) {
    gate.armedUntil = 0;
    close();
    return true;
  }
  gate.armedUntil = now + windowMs;
  hint();
  return true;
}

export function resetShellFormBackGate(gate: ShellFormBackGate): void {
  gate.armedUntil = 0;
}

const HOME_PATHS = new Set(['/', '/login']);

export function installCapacitorBackButton(getCurrentPath: () => string): () => void {
  if (!isCapacitorNativeApk()) return () => {};
  let sub: { remove: () => Promise<void> } | null = null;
  void App.addListener('backButton', () => {
    if (runShellBackHandlers()) return;
    const path = getCurrentPath();
    if (!HOME_PATHS.has(path)) {
      globalThis.history.back();
    }
  }).then((handle) => {
    sub = handle;
  });
  return () => {
    void sub?.remove();
    sub = null;
  };
}
